import React, { type PropsWithChildren } from "react";

type AppErrorBoundaryState = {
  hasError: boolean;
  message: string;
};

export default class AppErrorBoundary extends React.Component<PropsWithChildren, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = {
    hasError: false,
    message: "",
  };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return {
      hasError: true,
      message: error.message || "Unexpected application error",
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("AppErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center px-4">
          <div className="surface-card max-w-2xl px-8 py-14 text-center">
            <div className="text-xs font-semibold uppercase tracking-[0.24em] text-muted-foreground">Application error</div>
            <h1 className="mt-3 text-4xl font-bold text-foreground">The dashboard hit a runtime error.</h1>
            <p className="mt-4 text-sm leading-7 text-muted-foreground">{this.state.message}</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="pill-button mt-8 bg-[var(--pp-charcoal)] px-6 py-4 text-white"
            >
              Reload app
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
